import i18n from '@/utils/i18n';
import React, { useCallback, useRef } from 'react';
import { ActionToastContent } from '@/components/action-toast-content';
import { APP_ROUTES } from '@/navigators/routes';
import { AppStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';
import { useToasts } from '@/contexts/toast-context';

interface Options {
  source: string;
}

export const useOrderAlreadyPlacedToast = () => {
  const navigation = useNavigation<StackNavigationProp<AppStackParams>>();
  const { closeToast, showToast } = useToasts();

  const toastIDRef = useRef<string | null>(null);

  return useCallback(
    ({ source }: Options) => {
      if (toastIDRef.current) {
        return;
      }

      const toastID = showToast({
        autoCloseTimeout: 0,
        content: (
          <ActionToastContent
            buttonProps={{
              children: i18n.t('view_orders'),
              onPress: () => {
                navigation.navigate(APP_ROUTES.Orders);
                if (toastIDRef.current) {
                  closeToast(toastIDRef.current);
                }

                toastIDRef.current = null;
              },
              trackingData: {
                name: 'order_already_placed_toast.view_orders_button',
                properties: {
                  source,
                },
              },
            }}
            textContent={i18n.t('toast.order_already_placed')}
          />
        ),
      });

      toastIDRef.current = toastID || null;
    },
    [closeToast, navigation, showToast],
  );
};
